/**
 * @file
 * Use Select2 library to replace select elements with flexible markup.
 */

(function ($, Drupal) {
  Drupal.behaviors.select = {
    attach: function attach(context) {
      $.fn.select2.defaults.set('theme', 'custom');
      $.fn.select2.defaults.set('minimumResultsForSearch', 20);
      $.fn.select2.defaults.set('width', '100%');
      $.fn.select2.defaults.set('placeholder', Drupal.t('Please select …'));
      $.fn.select2.defaults.set('dropdownAutoWidth', true);

      $('.js-select-replace').each(function () {
        const $this = $(this);
        const $parentModal = $this.parents('dialog:first');
        // If inside modal, set this as parent instead of default (body).
        const $dropdownParent = $parentModal.length ? $parentModal : undefined;
        $this.select2({
          dropdownParent: $dropdownParent,
          placeholder: $this.siblings('label').text(),
        });
      });

      /* Adjustments for select-replacement inside the filter_bar */

      // Provide function to check select-value is not 'All' or 'current_last'
      function select_value_is_default(value) {
        return (value !== 'All' && value !== 'current_last');
      }

      let filterbarSelect = $('.filterbar .js-select-replace');

      once('awSelect', filterbarSelect).forEach(function(currentElement) {
        if (select_value_is_default($(currentElement).val())) {
          $(currentElement).siblings('label').addClass('is-hidden-label');
        } else {
          $(currentElement).siblings('label').removeClass('is-hidden-label');
        }
      });

      filterbarSelect.on('select2:select', function (e) {
        if (select_value_is_default(e.params.data.id)) {
          $(this).siblings('label').addClass('is-hidden-label');
        } else {
          $(this).siblings('label').removeClass('is-hidden-label');
        }
      });

      $(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
        $(this).closest(".select2-container").siblings('select:enabled').select2('open');
      });
    }
  };
})(jQuery, Drupal);
